import React, {createContext, useContext, useMemo} from 'react';
import Settings from 'src/Settings';
import Styles from 'src/components/Styles';

type Theme = {
  primary: string;
  secondary: string;
  success: string;
  text: {primary: string; secondary: string; disabled: string};
  bg: {card: string; screen: string};
};

const defaultTheme: Theme = {
  primary: Styles.Colors.PayNew.primary01,
  secondary: Styles.Colors.PayNew.neutralHuesBase09,
  success: Styles.Colors.PayNew.success,
  text: {
    primary: Styles.Colors.PayNew.black01,
    secondary: Styles.Colors.PayNew.darkHuesBase04,
    disabled: Styles.Colors.PayNew.neutralHuesBase09,
  },
  bg: {card: Styles.white, screen: Styles.Colors.PayNew.neutralHuesBase11},
};

const ThemeCtx = createContext<Theme>(defaultTheme);
export const useTheme = () => useContext(ThemeCtx);

export const BrandThemeProvider: React.FC<{children: React.ReactNode}> = ({
  children,
}) => {
  const value = useMemo<Theme>(() => {
    switch (Settings.buildType) {
      case 'canteen':
        return {
          ...defaultTheme,
          primary: Styles.Colors.Canteen.darkGreen,
        };
      case 'companykitchen':
        return {
          ...defaultTheme,
          primary: Styles.Colors.CompanyKitchen.green,
        };
      case 'refive':
        return {
          ...defaultTheme,
          primary: Styles.Colors.Refive.activeFooterBlue,
        };
      default:
        return defaultTheme;
    }
  }, []);
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
};
